import { setLocale } from '@adobe-fonts/site/lib/I18N.js';
import { localizeSharedMessages } from './shared.i18n.js';

export async function switchLocale(locale) {
  const fontSizeSliderMessages = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/settings-bar/font-size-slider/i18n/${locale}.json`);

  const fontSorterMessages = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/settings-bar/font-sorter/i18n/${locale}.json`);

  const openInCCXButtonMessages = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/ccx/open-in-ccx-button/i18n/${locale}.json`);

  const paginationMessages = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/pagination/i18n/${locale}.json`);

  const sampleTextMenuMessages = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/settings-bar/sample-text-menu/i18n/${locale}.json`);

  const variationCardMessages = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/variation-card/i18n/${locale}.json`);

  const viewOptionsMessages = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/settings-bar/view-options/i18n/${locale}.json`);

  // Libraries components
  const deleteLibraryDialogMessages = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/libraries/delete-library-dialog/i18n/${locale}.json`);

  const editLibraryDialogMessages = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/libraries/edit-library-dialog/i18n/${locale}.json`);

  const followLibraryButtonMessages = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/libraries/follow-library-button/i18n/${locale}.json`);

  const librariesToolbarMessages = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/libraries/libraries-toolbar/i18n/${locale}.json`);

  const libraryActionsMenuMessages = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/libraries/library-actions-menu/i18n/${locale}.json`);

  const libraryCardMessages = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/libraries/library-card/i18n/${locale}.json`);

  const libraryCardListMessages = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/libraries/library-card-list/i18n/${locale}.json`);

  const removeFromFavoritesDialog = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/libraries/remove-from-favorites-dialog/i18n/${locale}.json`);

  const removeLibraryFontDialogMessages = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/libraries/remove-library-font-dialog/i18n/${locale}.json`);

  const reportAbuseButtonMessages = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/libraries/report-abuse-button/i18n/${locale}.json`);

  const shareLibraryDialogMessages = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/libraries/share-library-dialog/i18n/${locale}.json`);

  const sharedMessages = await localizeSharedMessages(locale);

  setLocale(locale, {
    ...sharedMessages,
    ...fontSizeSliderMessages.default,
    ...fontSorterMessages.default,
    ...openInCCXButtonMessages.default,
    ...paginationMessages.default,
    ...sampleTextMenuMessages.default,
    ...variationCardMessages.default,
    ...viewOptionsMessages.default,
    ...deleteLibraryDialogMessages.default,
    ...editLibraryDialogMessages.default,
    ...followLibraryButtonMessages.default,
    ...librariesToolbarMessages.default,
    ...libraryActionsMenuMessages.default,
    ...libraryCardMessages.default,
    ...libraryCardListMessages.default,
    ...removeFromFavoritesDialog.default,
    ...removeLibraryFontDialogMessages.default,
    ...reportAbuseButtonMessages.default,
    ...shareLibraryDialogMessages.default
  });
}
